import ReactLoading from "react-loading";
import { Button, ExtendedButtonProps } from "@mui/material";

export interface ButtonOutlinedProps extends Omit<ExtendedButtonProps, "variant"> {
	variant?: "outlined" | "approve" | "reject" | "complete";
}

export const ButtonOutlined = ({
	"data-useremunit": useRemUnit = "false",
	loading = false,
	loadingType = "balls",
	variant = "outlined",
	children,
	...props
}: ButtonOutlinedProps) => {
	return (
		<Button disableElevation variant={variant} data-useremunit={useRemUnit} {...props}>
			{loading ? (
				<ReactLoading
					type={loadingType}
					width={useRemUnit ? "2.4rem" : "24px"}
					height={useRemUnit ? "2.4rem" : "24px"}
					color="currentColor"
				/>
			) : (
				children
			)}
		</Button>
	);
};
